import React, { useEffect, useRef, useState } from 'react';
import { FaCalendarAlt, FaSyncAlt } from 'react-icons/fa';
import './ManagementPolish.css';

/** React owns the toolbar: no portal target, DOM text lookup or MutationObserver. */
export default function ManagementHeaderActions({ prefix, loadRecords, onBirthdays, loading = false }) {
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState('');
  const busy = useRef(false);
  const request = useRef(0);
  const mounted = useRef(false);
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; request.current += 1; };
  }, []);
  const refresh = async () => {
    if (busy.current || loading) return;
    const ticket = ++request.current;
    busy.current = true; setRefreshing(true); setError('');
    try {
      const records = await loadRecords();
      if (!mounted.current || ticket !== request.current) return;
      if (!Array.isArray(records)) throw new Error('Invalid record list');
      const entity = prefix === 'attendees' ? 'attendee' : 'student';
      window.dispatchEvent(new CustomEvent(`ibpm:${entity}-list-refreshed`, { detail: { [prefix]: records } }));
    } catch {
      if (mounted.current && ticket === request.current) setError('N\u00e3o foi poss\u00edvel atualizar a lista. Tente novamente.');
    } finally {
      if (ticket === request.current) { busy.current = false; if (mounted.current) setRefreshing(false); }
    }
  };
  return <div className="management-polish__hero-actions">
    <div className="management-polish__hero-buttons" role="group" aria-label={'A\u00e7\u00f5es da lista'}>
      <button type="button" title="Aniversariantes" aria-label="Aniversariantes" disabled={loading} onClick={onBirthdays}>
        <FaCalendarAlt aria-hidden="true" /><span>Aniversariantes</span>
      </button>
      <button type="button" title="Sincronizar" aria-label="Sincronizar" aria-busy={refreshing} disabled={loading || refreshing} onClick={refresh}>
        <FaSyncAlt aria-hidden="true" className={refreshing ? 'management-polish__spinning' : ''} /><span>{refreshing ? 'Atualizando...' : 'Sincronizar'}</span>
      </button>
    </div>
    {error && <small role="alert" className="management-polish__hero-error">{error}</small>}
  </div>;
}
